// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"154":"4a6f6f6f","569":"a41f167d","683":"1de1c4bf"}[chunkId] + ".chunk.js";
};